import { Field, Form, Formik } from 'formik';
import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { IAddTeplar } from '../../../models/forms/IAddUpdateTeplar';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import LoaderButton from '../../../shared-components/button/loader-button';
import FormikFormFileInput from '../../../shared-components/FormikFormHandlers/FormikFormFileInput';
import { TeplarValidateSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import { CloseModalIcon } from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';

interface Iprops extends IAddEditFormProps<IAddTeplar> {
  duplicateRecords: string;
}

const AddTeplarPrintForm = (props: Iprops) => {
  return (
    <>
      <Modal
        className="correction-modal fancy-modal"
        show={true}
        centered
        onHide={() => {}}
      >
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id="import_teplar" />
            <button
              onClick={props.onModalClosed}
              disabled={props.isLoading}
              className="Crossicons"
            >
              <CloseModalIcon />
            </button>
          </Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={props.initialValues}
          enableReinitialize
          validationSchema={TeplarValidateSchema}
          validateOnBlur={false}
          onSubmit={async (values) => {
            props.submitHandler(values);
          }}
        >
          {({ dirty, setFieldValue }) => {
            return (
              <Form className="user-form">
                {props.isLoading && <FormLoader loading={props.isLoading} />}
                <Modal.Body>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style  col-form-label"
                          required={true}
                          label="file"
                        />
                        <Field
                          data-testid="file"
                          className="form-control"
                          name="formFile"
                          value={undefined}
                          invalidcharacter={[' ']}
                          validcharacter={['@', '#', '$', '-', '_', '.']}
                          placeholder=""
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          as={FormikFormFileInput}
                          onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            if (
                              event.target.files != null &&
                              event.target.files.length > 0
                            ) {
                              setFieldValue('formFile', event.target.files[0]);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {props.duplicateRecords.length > 0 && (
                    <div className="duplicated-data">
                      {formatMessage('records_already_exist')}
                      {props.duplicateRecords}
                    </div>
                  )}
                </Modal.Body>

                <Modal.Footer>
                  <div className="d-flex justify-content-center ">
                    <div className="row tab-action g-0">
                      <div className="col-12">
                        <Button
                          variant="light-danger"
                          type="button"
                          onClick={props.onModalClosed}
                          disabled={props.isLoading}
                        >
                          {/* <FormattedMessage id="cancel" /> */}
                          {props.duplicateRecords &&
                          props.duplicateRecords.length > 0 ? (
                            <FormattedMessage id="ok" />
                          ) : (
                            <FormattedMessage id="cancel" />
                          )}
                        </Button>
                        {!props.duplicateRecords && (
                          <LoaderButton
                            type="submit"
                            isLoading={props.isLoading}
                            text="button_save"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </Modal.Footer>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};

export default AddTeplarPrintForm;
